export default __webpack_public_path__ + "static/media/close_icon.e199f0c1.svg";